import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ScreenReaderOnlyStyled } from './screenReaderOnly.styled';
const ScreenReaderOnly = React.forwardRef(({ children, as, id, ariaLive, role, dataTestId = 'screen-reader' }, ref) => {
    return (_jsx(ScreenReaderOnlyStyled, { ref: ref, "aria-live": ariaLive, as: as, "data-testid": dataTestId, id: id, role: role, children: children }));
});
ScreenReaderOnly.displayName = 'ScreenReaderOnly';
export { ScreenReaderOnly };
//# sourceMappingURL=screenReaderOnly.js.map